import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';

function ActivateAccount() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('activating'); // 'activating', 'success', 'error'
  const [message, setMessage] = useState('');
  const [userInfo, setUserInfo] = useState(null);
  
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid activation link. Please check your email for the correct link.');
      return;
    }

    activateAccount();
  }, [token]);

  const activateAccount = async () => {
    try {
      setStatus('activating');
      const response = await authService.activate(token);
      
      // Check if response has error status code
      if (response.statusCode && response.statusCode >= 400) {
        const errorBody = JSON.parse(response.body);
        throw new Error(errorBody.error || 'Activation failed');
      }
      
      const respBody = JSON.parse(response.body);
      
      if (respBody.error) {
        throw new Error(respBody.error);
      }

      setStatus('success');
      setMessage(respBody.message);
      setUserInfo(respBody.user);
    } catch (error) {
      setStatus('error');
      setMessage(error.message || 'Failed to activate account. Please try again or contact support.');
    }
  };

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  if (status === 'activating') {
    return (
      <div className="container">
        <div className="card" style={{ maxWidth: '400px', margin: '50px auto', textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', marginBottom: '20px' }}>⏳</div>
          <h2 style={{ color: '#ff6b35', marginBottom: '24px' }}>
            Activating Your Account
          </h2>
          <p style={{ color: '#e0e0e0' }}>
            Please wait while we activate your account...
          </p>
          <div style={{ 
            width: '40px', 
            height: '40px', 
            border: '3px solid rgba(255, 107, 53, 0.3)',
            borderTop: '3px solid #ff6b35',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '20px auto'
          }}></div>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div className="container">
        <div className="card" style={{ maxWidth: '500px', margin: '50px auto', textAlign: 'center' }}>
          <div style={{ fontSize: '4rem', marginBottom: '20px' }}>🎉</div>
          
          <h2 style={{ color: '#27ae60', marginBottom: '24px' }}>
            Account Activated!
          </h2>
          
          <div style={{ 
            backgroundColor: 'rgba(39, 174, 96, 0.1)',
            border: '1px solid rgba(39, 174, 96, 0.3)',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '30px'
          }}>
            <p style={{ color: '#e0e0e0', fontSize: '16px', marginBottom: '15px' }}>
              {message}
            </p>
            
            {userInfo && (
              <div style={{ marginTop: '15px' }}>
                <p style={{ color: '#b0b0b0', fontSize: '14px' }}>
                  Welcome, <strong style={{ color: '#27ae60' }}>{userInfo.name}</strong>!
                  <br />
                  Family: <strong style={{ color: '#27ae60' }}>{userInfo.familyName}</strong>
                </p>
              </div>
            )}
          </div>
          
          <div style={{ 
            backgroundColor: 'rgba(52, 152, 219, 0.1)',
            border: '1px solid rgba(52, 152, 219, 0.3)',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '30px'
          }}>
            <h3 style={{ color: '#3498db', marginBottom: '15px', fontSize: '18px' }}>
              🚀 Your 30-Day Free Trial Has Started!
            </h3>
            <p style={{ color: '#e0e0e0', fontSize: '14px', lineHeight: '1.5' }}>
              You now have full access to all features. When you log in for the first time, 
              you'll see a quick tutorial to help you get started. Our support team will contact you 
              before your trial ends to help you choose the perfect plan.
            </p>
          </div>
          
          <button
            onClick={handleLoginRedirect}
            className="btn"
            style={{ 
              width: '100%',
              fontSize: '16px',
              fontWeight: '600'
            }}
          >
            Continue to Login
          </button>
          
          <div style={{ 
            borderTop: '1px solid #333',
            paddingTop: '20px',
            marginTop: '30px'
          }}>
            <p style={{ color: '#666', fontSize: '12px' }}>
              Ready to start tracking your family budget!
              <br />
              Questions? Contact us at info@duttonbiz.com
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Error state
  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '500px', margin: '50px auto', textAlign: 'center' }}>
        <div style={{ fontSize: '4rem', marginBottom: '20px' }}>❌</div>
        
        <h2 style={{ color: '#e74c3c', marginBottom: '24px' }}>
          Activation Failed
        </h2>
        
        <div style={{ 
          backgroundColor: 'rgba(231, 76, 60, 0.1)',
          border: '1px solid rgba(231, 76, 60, 0.3)',
          borderRadius: '8px',
          padding: '20px',
          marginBottom: '30px'
        }}>
          <p style={{ color: '#e0e0e0', fontSize: '16px' }}>
            {message}
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <button
            onClick={() => navigate('/login?mode=register')}
            style={{
              background: '#ff6b35',
              border: 'none',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              marginRight: '10px'
            }}
          >
            Try Signing Up Again
          </button>
          
          <button
            onClick={() => navigate('/login')}
            style={{
              background: 'none',
              border: '1px solid #666',
              color: '#b0b0b0',
              padding: '12px 24px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Back to Login
          </button>
        </div>
        
        <div style={{ 
          borderTop: '1px solid #333',
          paddingTop: '20px',
          marginTop: '30px'
        }}>
          <p style={{ color: '#666', fontSize: '12px' }}>
            Need help? Contact us at info@duttonbiz.com
            <br />
            We'll help you get your account activated.
          </p>
        </div>
      </div>
    </div>
  );
}

export default ActivateAccount;